export enum AnnouncementModalActionsEnum {
  CREATE = 'create',
  MODIFY = 'modify',
}
